import { render, staticRenderFns } from "./PersonEmergencyContactsTable.vue?vue&type=template&id=33b12fea&scoped=true&"
import script from "./PersonEmergencyContactsTable.vue?vue&type=script&lang=js&"
export * from "./PersonEmergencyContactsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b12fea",
  null
  
)

export default component.exports